var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7505 23.75V11.25H5.00049V23.75H13.7505ZM13.7505 8.75V5C13.7505 4.66848 13.8822 4.35054 14.1166 4.11612C14.351 3.8817 14.669 3.75 15.0005 3.75H26.2505C26.582 3.75 26.9 3.8817 27.1344 4.11612C27.3688 4.35054 27.5005 4.66848 27.5005 5V25C27.5005 25.3315 27.3688 25.6495 27.1344 25.8839C26.9 26.1183 26.582 26.25 26.2505 26.25H3.75049C3.41897 26.25 3.10103 26.1183 2.8666 25.8839C2.63218 25.6495 2.50049 25.3315 2.50049 25V10C2.50049 9.66848 2.63218 9.35054 2.8666 9.11612C3.10103 8.8817 3.41897 8.75 3.75049 8.75H13.7505ZM16.2505 6.25V23.75H25.0005V6.25H16.2505ZM6.25049 20H12.5005V22.5H6.25049V20ZM17.5005 20H23.7505V22.5H17.5005V20ZM17.5005 16.25H23.7505V18.75H17.5005V16.25ZM17.5005 12.5H23.7505V15H17.5005V12.5ZM6.25049 16.25H12.5005V18.75H6.25049V16.25Z",
    fill: "url(#paint0_linear_655_1554)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_655_1554",
    x1: 1.87549,
    y1: 4.5,
    x2: 28.5005,
    y2: 26.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B3AD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBBE3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.8430be84e21cd8592d5d3654a2c2877e.svg";
export { ForwardRef as ReactComponent };